import { Injectable } from '@angular/core';
import has from 'lodash-es/has';
import { Observable, Subject } from 'rxjs';
import { SECTION_COMMAND } from './section.constants';

@Injectable({
    providedIn: 'root'
})
export class SectionService {
    private eventSubject = new Subject<any>();
    private expandedSections = {};

    constructor() { }

    public sectionClicked(id: string, currentState: boolean, futureState: boolean) {
        // Check to see if the section has been clicked
        if (!has(this.expandedSections, id)) {
            this.expandedSections[id] = currentState;
        }

        // Tell everyone to close
        this.eventSubject.next({
            command: SECTION_COMMAND.CLOSE
        });

        // Tell this one to open
        if (futureState) {
            this.eventSubject.next({
                id,
                command: SECTION_COMMAND.OPEN
            });
        }
    }

    public clickEventObservable(): Observable<any> {
        return this.eventSubject.asObservable();
    }
}
